import * as Ably from 'ably'
import store from '@/store'
import localStore from 'store'

let ablyClient = null
let presenceChannel = null
export async function initPresence(user) {
  try {
    console.log('Initializing Ably presence service')

    ablyClient = new Ably.Realtime({
      authCallback: async (_params, callback) => {
        try {
          const token = await fetchAblyTokenWithRetry()
          callback(null, token)
        } catch (err) {
          console.error('Auth callback failed:', err)
          callback(err)
        }
      }
    })

    // Wait for connection
    await new Promise((resolve, reject) => {
      ablyClient.connection.on('connected', resolve)
      ablyClient.connection.on('failed', reject)
      ablyClient.connection.on('failed', (stateChange) => {
        console.error('Ably connection failed:', stateChange.reason)
      })

      ablyClient.connection.on('disconnected', (stateChange) => {
        console.warn('Ably disconnected:', stateChange.reason)
      })

      // ablyClient.connection.on('authorizationFailed', (err) => {
      //   console.error('Ably auth failed:', err)
      // })
    })

    // console.log('Ably connected')
  } catch (error) {
    console.error('Failed to initialize Ably:', error)
  }
}

async function fetchAblyTokenWithRetry(retries = 3) {
  const url = process.env.VUE_APP_ABLY_URL + '/api/ably-token'
  const jwtToken = await localStore.get('accessToken')
  await wait(2000)
  for (let i = 0; i < retries; i++) {
    try {
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + jwtToken
        }
      })

      if (!res.ok) throw new Error('HTTP ' + res.status)

      const json = await res.json()
      if (!json || !json.keyName) {
        throw new Error('Invalid Ably token response')
      }

      return json
    } catch (err) {
      console.warn(`Ably token fetch failed (${i + 1}/${retries})`, err)
      if (i < retries - 1) {
        await wait(1000 * (i + 1)) // backoff
      }
    }
  }
  console.error('All retries to fetch Ably token failed')
  throw new Error('Failed to fetch Ably token after retries')
}

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export async function connectPresence(user) {
  // console.log('Connecting to Ably presence service for user:', user.email)
  // if (!ablyClient) {
  await initPresence(user)
  // }
  if (!ablyClient) return

  const channelName = process.env.VUE_APP_ABLY_PRESENCE_CHANNEL
  // console.log('Connecting to presence channel:', channelName)
  presenceChannel = ablyClient.channels.get(channelName)
  // console.log('auth:', ablyClient)
  // Enter or update presence
  const presenceData = {
    userId: user.email,
    name: user.name,
    username: user.email,
    appName: user.appName,
    clientId: ablyClient.auth.clientId,
    connectionId: ablyClient.connection.id,
    company: user.company,
    // Add more user data as needed
  }
  // console.log('Entering presence with data:', presenceData)
  // Check if already present, update if so
  const presenceMembers = await presenceChannel.presence.get()
  const isPresent = presenceMembers.some(member => member.clientId === ablyClient.auth.clientId)

  if (isPresent) {
    await presenceChannel.presence.update(presenceData)
  } else {
    await presenceChannel.presence.enter(presenceData)
  }

  // Listen to presence events
  presenceChannel.presence.subscribe('enter', (member) => {
    updateOnlineUsers()
  })
  presenceChannel.presence.subscribe('leave', (member) => {
    updateOnlineUsers()
  })
  presenceChannel.presence.subscribe('update', (member) => {
    // console.log('Presence update received:', member)
    updateOnlineUsers()
  })

  // subscribe to a publish messages on the channel
  const msgGroup = user.appName + user.company
  presenceChannel.subscribe(msgGroup, (msg) => {
    console.log('Message received on presence channel:', msg)
  })

  // Initial update
  updateOnlineUsers()

  // console.log('Presence connected')
}

export async function disconnectPresence() {
  if (presenceChannel) {
    await presenceChannel.presence.leave()
    presenceChannel = null
  }
  if (ablyClient) {
    ablyClient.close()
    ablyClient = null
  }
  // Clear online users
  store.commit('user/SET_STATE', { onlineUsers: [] })
  // console.log('Presence disconnected')
}

async function updateOnlineUsers() {
  if (!presenceChannel) return
  try {
    if (!store.state.user.isHidden) return
    const presenceMembers = await presenceChannel.presence.get()
    // console.log('Presence members:', presenceMembers)
    const onlineUsers = presenceMembers.map(member => member.data)
    // console.log('onlineUsers', onlineUsers);

    store.commit('user/SET_STATE', { onlineUsers })
  } catch (error) {
    console.error('Failed to get presence members:', error)
  }
}
